export default "__VITE_ASSET__B0lPpNl4__"